"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
const TooltipContent = ({
  id,
  values,
  icannFeeMessage,
  hasIcannFee,
  icannFee
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, id && /*#__PURE__*/_react.default.createElement("p", null, formatMessage({
    id
  }, {
    ...values
  })), hasIcannFee && /*#__PURE__*/_react.default.createElement("p", null, formatMessage({
    id: icannFeeMessage
  }, {
    icannFee
  })));
};
TooltipContent.propTypes = {
  id: _propTypes.default.string,
  values: _propTypes.default.object,
  icannFeeMessage: _propTypes.default.string,
  hasIcannFee: _propTypes.default.bool,
  icannFee: _propTypes.default.string
};
var _default = exports.default = TooltipContent;